import React from 'react';
import styled from 'styled-components';

const Icon = styled.svg`
  width: 34px;
  height: 50px;

  @media (max-width: 767px) {
    height: 40px;
    width: 27px;
  }
`;

const CalendarIcon = props => (
  <Icon
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 50"
    fill={props.fill}
  >
    <g>
      <path d="M16.51,32.36H2.32a.27.27,0,0,1-.26-.27V21.84H16.77V32.1a.27.27,0,0,1-.27.27M2.32,18.69H3.63v.53a.53.53,0,1,0,1.05,0v-.53h9.47v.53a.53.53,0,1,0,1.05,0v-.53h1.31a.27.27,0,0,1,.27.27v1.84H2.05V19a.27.27,0,0,1,.27-.27m14.19-1.05H15.2v-.53a.53.53,0,1,0-1.05,0v.53H4.68v-.53a.53.53,0,1,0-1.05,0v.53H2.32A1.32,1.32,0,0,0,1,19V32.1a1.32,1.32,0,0,0,1.32,1.32H16.51a1.32,1.32,0,0,0,1.32-1.32V19a1.32,1.32,0,0,0-1.32-1.32" />
      <path d="M4.15,25.53a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M4.15,27.63a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M4.15,29.73a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M12.57,23.42a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M12.57,25.53a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M12.57,27.63a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M12.57,29.73a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M14.67,23.42a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M14.67,25.53a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M14.67,27.63a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M8.36,23.42a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M8.36,25.53a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M8.36,27.63a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M8.36,29.73a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M6.26,23.42a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M6.26,25.53a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M6.26,27.63a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M6.26,29.73a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M10.46,23.42a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M10.46,25.53a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M10.46,27.63a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
      <path d="M10.46,29.73a.53.53,0,1,0,.53.53.53.53,0,0,0-.53-.53" />
    </g>
  </Icon>
);

export default CalendarIcon;
